import axios from 'axios';
import toast from 'react-hot-toast';
import { API_URL } from '../env';

const api = axios.create({
  baseURL: API_URL,
  withCredentials: true,
  timeout: 10000,
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    const { response } = error;

    if (response?.status === 401) {
      if (!window.location.pathname.startsWith('/login')) {
        window.location.href = `${API_URL}/api/auth/login?redirect_uri=${encodeURIComponent(window.location.href)}`;
      }
      return Promise.reject(error);
    }

    if (response?.status >= 500) {
      toast.error('Server error. Please try again later.');
    } else if (error.message === 'Network Error') {
      toast.error('Connection lost. Please check your internet.');
    }
    return Promise.reject(error);
  }
);

// Helper methods
api.getTags = () => api.get('/api/library/tags');
api.createTag = (data) => api.post('/api/library/tags', data);
api.getLibraryScenarios = (params) => api.get('/api/library/scenarios', { params });
api.getLibraryScenario = (id) => api.get(`/api/library/scenarios/${id}`);
api.createLibraryScenario = (data) => api.post('/api/library/scenarios', data);
api.requestExamination = (sessionId, system) => api.post(`/api/simulator/session/${sessionId}/examine`, { system });
api.requestInvestigation = (sessionId, type, specific) => api.post(`/api/simulator/session/${sessionId}/investigate`, { type, specific });
api.completeSession = (sessionId) => api.post(`/api/simulator/session/${sessionId}/complete`);
api.getSessionScore = (sessionId) => api.get(`/api/scoring/session/${sessionId}`);
api.requestSessionScoring = (sessionId) => api.post(`/api/scoring/session/${sessionId}`);

// SCA API helpers
api.createSCAScenario = (data) => api.post('/api/sca/scenario', data);
api.getSCAScenarios = (params) => api.get('/api/sca/scenarios', { params });
api.getSCAScenario = (id) => api.get(`/api/sca/scenarios/${id}`);
api.deleteSCAScenario = (id) => api.delete(`/api/sca/scenarios/${id}`);
api.createSCASession = (scenarioId) => api.post('/api/sca/session', { scenario_id: scenarioId });
api.getSCASession = (sessionId) => api.get(`/api/sca/session/${sessionId}`);
api.endSCASession = (sessionId, transcript, durationSeconds) =>
  api.post(`/api/sca/session/${sessionId}/end`, { transcript, duration_seconds: durationSeconds });
api.scoreSCASession = (sessionId) => api.post(`/api/sca/session/${sessionId}/score`);
api.getSCAScore = (sessionId) => api.get(`/api/sca/session/${sessionId}/score`);

// TTS API helpers
api.getTTSConfig = () => api.get('/api/tts/config');
api.updateTTSConfig = (config) => api.put('/api/tts/config', config);
api.getTTSVoices = (engine) => api.get(`/api/tts/voices/${engine}`);
api.synthesizeTTS = async (text, voiceId, rate, engine = null) => {
  const response = await api.post('/api/tts/synthesize',
    { text, voice_id: voiceId, rate, engine },
    { responseType: 'blob' }
  );
  return response.data; // Blob
};

export default api;
